import { recentQuotesStyles as styles } from "@insite/content-library/Widgets/Common/RecentQuotes";
import {
    cardContainerCommonStyles,
    cardNoItemsCommonStyles,
    cardSummaryCommonStyles,
} from "@solveindustrial/WidgetExtensions/Common/RecentOrdersExtension";
import { css } from "styled-components";

styles.cardContainer = {
    ...styles.cardContainer,
    cardDivider: {
        css: css`
            ${styles.cardContainer?.cardDivider?.css};
            ${cardContainerCommonStyles}
        `,
    },
};

styles.quoteSummaryCard = {
    ...styles.quoteSummaryCard,
    quoteSummaryCardGridItem: {
        ...styles.quoteSummaryCard?.quoteSummaryCardGridItem,
        css: css`
            ${styles.quoteSummaryCard?.quoteSummaryCardGridItem?.css};
            ${cardSummaryCommonStyles}
        `,
    },
};

styles.noQuotesGridItem = {
    ...styles.noQuotesGridItem,
    css: css`
        ${styles.noQuotesGridItem?.css};
        ${cardNoItemsCommonStyles}
    `,
};
